import TranslationTablesMappingController from "../controllers/TranslationTablesMapping/TranslationTablesMapping";

const translationTablesMapping = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: TranslationTablesMappingController,
    exact,
    queries: TranslationTablesMappingController.queries,
    title: [title],
    components: [],
});

export default translationTablesMapping;
